import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid,  LinearProgress,   Paper, Snackbar, SnackbarCloseReason, TextField } from '@mui/material';
import { useState } from 'react';
import { DecimoService } from '../../../shared/services/api/rh/DecimoTerceiro/DecimoService';
import DeleteIcon from '@mui/icons-material/Delete';
           
export const GeraDecimo: React.FC = () => {                      
  const [isLoading, setIsLoading] = useState(false); 
  const [ano, setAno] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
      
  const [openConfirm, setOpenConfirm] = useState(false);
        
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };
      
  const handleDelete = () => {
    setOpenConfirm(true); 
  };
      
  const handleConfirmDelete = () => {
    if(ano === ''){
      setOpenConfirm(false);
      setTms('error');
      setMsg('Por favor, informe o ano.');
      setOpenmsg(true);     
    }else{
      setIsLoading(true);                         
      DecimoService                 
        .deleteAno(ano)   
        .then((result) => {           
          setIsLoading(false);              
          if (result instanceof Error) {                  
            setOpenConfirm(false);
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);              
          }else {   
            setOpenConfirm(false);
            setTms('success');
            setMsg('Registro apagado com sucesso!');
            setOpenmsg(true);
          }             
        });  
    }
   
  };
      
  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };  
                      
  const handleGera = () => {            
    setIsLoading(true);                         
    DecimoService                 
      .create(ano)      
      .then((result) => {           
        setIsLoading(false);              
        if (result instanceof Error) {                
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);                    
        }else {   
          setTms('success');
          setMsg('Decimo Gerada Com Sucesso!');
          setOpenmsg(true); 
        }             
      });              
  };   
                                                         
  return (
    <Box  alignItems="center" width='auto' alignContent='center' height="auto"  display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>;
      <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert
          severity="warning"  
          variant="filled"
          sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
          action={
            <>
              <Button color="inherit" size="small" onClick={handleConfirmDelete}>
                          Sim
              </Button>
              <Button color="inherit" size="small" onClick={handleCancelDelete}>
                          Nâo
              </Button>
            </>
          }
        >
          Realmente deseja Excluir a Decimo Terceiro?
        </Alert>
      </Snackbar>
      <Box gap={1}  padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='auto' height="80%" margin={1}  alignContent='center'></Box>
      <Box   width='auto' alignItems="center"  component={Paper} height="auto" margin={1} 
        alignContent='center'>       
        <DialogTitle>Gera Decimo Terceiro</DialogTitle>
        <DialogContent  dividers>    
          {isLoading && (             
            <Grid item>        
              <LinearProgress variant='indeterminate' />       
            </Grid>                              
          )}   
          <Grid container  padding={1} item direction="row" gap={2}>
            <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  fullWidth
                  size='small'
                  value={ano}
                  type='number'
                  disabled={isLoading}
                  label='Ano'
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setAno(event.target.value);
                  }}
                />
              </Grid> 
            </Grid> 
          </Grid>         
        </DialogContent>     
        <DialogActions>
          <Box flex={1} display="flex" justifyContent="start">
            <Button fullWidth variant='contained' color='error'  startIcon={<DeleteIcon />} onClick={handleDelete}>Excluir</Button>
          </Box>
          <Button fullWidth variant='contained' autoFocus onClick={handleGera}>Gera</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   